import { CalculatorSteps, type TileOptionSelections } from "../types";
import fetchRidgeAccessories from "./fetchRidgeAccessories";
import type { Data } from "../types";

export const navigateToGutterSelectionStep = async ({
  gutters,
  setSelectedStep,
  esIndexNameProduct,
  tileOptions,
  setTileOptions
}: {
  gutters: Data["gutters"];
  setSelectedStep: (step: CalculatorSteps) => void;
  setTileOptions: (tileOptions?: TileOptionSelections) => void;
  esIndexNameProduct?: string;
  tileOptions?: TileOptionSelections;
}) => {
  if (!Object.keys(gutters).length) {
    await fetchRidgeAccessories({
      tileOptions,
      setTileOptions,
      esIndexNameProduct
    });
    setSelectedStep(CalculatorSteps.YourSolutionContains);
    return;
  }

  setSelectedStep(CalculatorSteps.Guttering);
};
